import React from 'react';
import { experimental } from '@trp-beacon-ui-kit/react-theme/warnings';

import InputField from '../InputField';

const CheckboxField = (props) => (
  <InputField elementType="input" titlePosition="right" {...props} getValue={(current) => current.checked} type="checkbox" />
);

export default experimental(CheckboxField);
